<template>
    <div class="page">
        <div class="workspace">
            <div class="ws-unit">
                <div class="ws-unit-header ">
                    <div>
                        <el-button
                            type="primary"
                            size="small"
                            round
                            icon="el-icon-plus"
                            @click="create"
                        >添加</el-button>
                    </div>
                    <div class="ws-unit-toolbar">
                        <el-form :inline="true">
                            <el-form-item>
                                <el-input
                                    placeholder="请输入关键词"
                                    v-model="filter.keyword"
                                    clearable
                                    @clear="onSearch"
                                    class="input-with-select"
                                    size="mini"
                                >
                                    <el-button
                                        slot="append"
                                        icon="el-icon-search"
                                        @click="onSearch"
                                    ></el-button>
                                </el-input>
                            </el-form-item>
                            <el-form-item>
                                <ox-select
                                    size="mini"
                                    schema="domain"
                                    label-field="name"
                                    placeholder="请选择技术领域"
                                    v-model="filter.domain"
                                    :query="domainQuery"
                                    style="width: 100%"
                                    @change="onSearch"
                                />
                            </el-form-item>
                            <el-form-item>
                                <ox-select
                                    size="mini"
                                    schema="company"
                                    label-field="name"
                                    placeholder="请选择公司"
                                    v-model="filter.company"
                                    style="width: 100%"
                                    @change="onSearch"
                                />
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
                <div class="ws-unit-body">
                    <demand-table ref="table" />
                </div>
            </div>
        </div>
        <demand-form
            @success="onSaveSuccess"
            ref="dialog"
        />
    </div>
</template>

<script>
import OxSelect from "../../ox/components/form/OxSelect";
import DemandTable from "./Table";
import DemandForm from "./Form";

export default {
    name: "Product",
    components: {
        OxSelect,
        DemandTable,
        DemandForm
    },
    data: function() {
        return {
            filter: {
                keyword: null,
                domain: null,
                company: null
            }
        };
    },
    computed: {
        domainQuery() {
            const query = new window.BaaS.Query();
            query.compare("category", "=", "demand");
            return query;
        }
    },
    methods: {
        create() {
            this.$refs.dialog.show();
        },
        onSearch(){
          this.$refs.table.loadData(1);
        },
        onSaveSuccess() {
            this.$refs.table.loadData();
        }
    }
};
</script>

<style scoped>
</style>